import { combineReducers } from "redux";
import * as actions from '../../actions/types';

const blocks = (state = [], action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_FETCH_SUCCESS:
            return action.data.blocks;
        default:
            return state;
    }
}

const catalogItems = (state = [], action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_FETCH_SUCCESS:
            return reduceCandybarItemsEntities(action.data.catalog);
        case actions.CHECKOUT_ABANDON:
        case actions.CHECKOUT_INIT:
            return [];
        default:
            return state;
    }
};

const reduceCandybarItemsEntities = catalog => {
    return catalog.reduce((result, category) => {
        return result.concat(category.items.map(item => item.id));
    }, []);
};
  
const favorites = (state = [], action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_ITEM_FAV_ADD:
            return state.indexOf(action.itemId) > -1 ? state : state.concat([action.itemId]);
        case actions.CHECKOUT_CANDYBAR_ITEM_FAV_REMOVE:
            return favRemove(state, action.itemId);
        case actions.USER_PRE_CHECKOUT_FETCH_SUCCESS:
            return ('candybar' in action.data) ? action.data.candybar.favorites : [];
        default:
            return state;
    }
}

function favRemove(state, itemId) {
    const i = state.indexOf(itemId);

    if (i < 0) return state;
    
    state.splice(i, 1);

    return state.concat([]);
}

const isLoading = (state = false, action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_IS_LOADING:
            return action.isLoading;
        case actions.CHECKOUT_CANDYBAR_FETCH_ERROR:
            return false;
        default:
            return state;
    }
};

const loadError = (state = false, action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_FETCH_ERROR:
            return true;
        case actions.CHECKOUT_CANDYBAR_FETCH_SUCCESS:
            return false;
        default:
            return state;
    }
};

const selectedCategoryId = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_FETCH_SUCCESS:
            return null;
        case actions.CHECKOUT_CANDYBAR_CATEGORY_SELECT:
            return action.categoryId;
        default:
            return state;
    }
};

const selectedItemId = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_ITEM_SELECT:
            return action.itemId;
        case actions.CHECKOUT_CANDYBAR_ITEM_EDIT_CANCEL:
            return null;
        default:
            return state;
    }
};

const selectedUnitId = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_CANDYBAR_ITEM_SELECT:
            return action.unitId;
        default:
            return state;
    }
};

const candybar = combineReducers({
    blocks,
    catalogItems,
    favorites,
    isLoading,
    loadError,
    selectedCategoryId,
    selectedItemId,
    selectedUnitId
});

export default candybar;